function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 15 14" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.347 11.239l-4.408 2.317.842-4.909L.214 5.171l4.929-.716L7.347-.011l2.204 4.466 4.929.716-3.566 3.476.842 4.909z" fillRule="evenodd" /></svg>;
});